import { MEMBER_ROLE } from '@common'

/**
 * Check if member is regular member (only Member role, no other roles)
 * @param {Object} memberData - Member data object
 * @param {Array} memberData.assignments - Array of role assignments
 * @returns {boolean} true if member is regular member, false otherwise
 */
export const isRegularMember = memberData => {
    if (!memberData?.assignments || !Array.isArray(memberData.assignments) || memberData.assignments.length === 0) {
        // If no assignments, treat as regular member
        return true
    }

    // Check if member has only Member role (role.id === 1) and no other roles
    const hasOnlyMemberRole = memberData.assignments.every(assignment => {
        const roleId = assignment?.role?.id
        return roleId === MEMBER_ROLE.Member || roleId === String(MEMBER_ROLE.Member) || parseInt(roleId) === MEMBER_ROLE.Member
    })

    // Also check if there are any non-Member roles
    const hasNonMemberRole = memberData.assignments.some(assignment => {
        const roleId = assignment?.role?.id
        const roleIdNum = typeof roleId === 'string' ? parseInt(roleId) : roleId
        return roleIdNum !== MEMBER_ROLE.Member && roleIdNum !== null && roleIdNum !== undefined
    })

    // Regular member = has only Member role and no other roles
    return hasOnlyMemberRole && !hasNonMemberRole
}
